"use client";

import { createPortal } from "react-dom";
import AuthRequiredSheet from "./AuthRequiredSheet";
import { useIsDesktop } from "@/app/hooks/useIsDesktop";
import AuthRequiredModal from "../../elements/modal/AuthRequiredModal";

interface Props {
  open: boolean;
  onClose: () => void;
  title?: string;
  description?: string;
  continueHref?: string;
  onContinueClick?: () => void;
}

const AuthRequired = ({ open, onClose, title, description, continueHref, onContinueClick }: Props) => {
  const isDesktop = useIsDesktop();

  if (typeof window === "undefined") return null;
  if (!open || isDesktop === null) return null;

  return createPortal(
    <>
      <div className="fixed inset-0 bg-black/50 z-[9990]" onClick={onClose} />

      {isDesktop ? (
        <AuthRequiredModal onClose={onClose} title={title} description={description} continueHref={continueHref} onContinueClick={onContinueClick} />
      ) : (
        <AuthRequiredSheet title={title} description={description} continueHref={continueHref} onContinueClick={onContinueClick} />
      )}
    </>,
    document.body,
  );
};

export default AuthRequired;
